"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoint = void 0;
var _throttle = require("../performance/throttle");
var _react = require("react");
const getConfigForWidth = function (config) {
  let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.innerWidth;
  return config.sort((a, b) => b.value - a.value).find(configObj => {
    return width >= configObj.value;
  }) || {
    key: "unknown",
    value: 0
  };
};

/**
 * Hook to expose current breakpoint by key and value on resize events
 *
 * @name useBreakpoint
 * @param {object} config Object containing name/values defining breakpoints
 * @param {array} Hooks array containing breakpoint and setBreakpoint
 */
const useBreakpoint = config => {
  const [breakpoint, setBreakPoint] = (0, _react.useState)(() => getConfigForWidth(config));
  (0, _react.useEffect)(() => {
    const findBreakpoint = (0, _throttle.throttle)(() => {
      setBreakPoint(getConfigForWidth(config));
    }, 200);
    window.addEventListener("resize", findBreakpoint);
    return () => {
      window.removeEventListener("resize", findBreakpoint);
    };
  }, [config]);
  return breakpoint;
};
exports.useBreakpoint = useBreakpoint;